// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-ea8d67fe]{left:50%;transform:translateX(-50%)}.v-enter-active[data-v-ea8d67fe],.v-leave-active[data-v-ea8d67fe]{transition:opacity .5s ease,transform .3s ease-in}.v-enter[data-v-ea8d67fe],.v-leave-to[data-v-ea8d67fe]{opacity:0;transform:scale(.23)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
